function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M68 638l3 -5c1,-1 2,-3 3,-5 7,-6 -7,-4 13,-5 8,21 4,66 4,92l250 0c0,-26 -5,-71 3,-92l17 10c0,0 1,2 1,2 0,1 0,2 1,3 44,-14 78,-43 61,-102 -14,-54 -63,-47 -120,-51 -29,-1 1,20 -24,55 -12,17 -29,28 -57,30 -63,4 -84,-28 -85,-87 -56,13 -107,-11 -130,46 -25,61 14,97 60,109z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M848 193c-23,-7 -124,-3 -157,-3 -12,-5 -11,-8 -17,-18l-65 -100c-15,-24 -17,-25 -36,-5 -120,121 -4,314 156,274 55,-14 129,-79 119,-148z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M219 520c19,-9 96,-79 109,-94 37,-45 37,-100 37,-170 -22,21 -14,61 -50,76 -40,16 -54,-20 -96,-20 -39,-1 -54,34 -94,19 -16,-7 -23,-15 -30,-33 -3,-7 -5,-14 -8,-21l-7 -16c-3,-5 -3,-5 -5,-7 -5,105 7,161 86,221 17,13 41,36 58,45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M74 187c3,17 33,95 41,110 23,44 62,-4 104,-4 45,0 84,50 106,5 6,-13 39,-99 39,-107 -63,-8 -68,7 -118,-29 -42,-29 6,-41 -115,-36 -15,19 -19,50 -57,61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M37 56c0,68 58,51 157,51 75,0 11,65 171,65 0,-141 -25,-80 -85,-103 -8,-39 3,-61 -53,-61l7 0c-65,0 -131,0 -197,0l0 48z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M606 25c0,19 25,49 40,72 11,18 31,56 48,67 21,-7 53,-54 85,-82 11,-9 22,-19 27,-33 -13,-24 -55,-43 -90,-47 -52,-7 -74,7 -110,23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M739 181l106 0c19,0 23,-1 22,-21 -2,-30 -22,-79 -44,-94 -16,3 -23,18 -32,27l-61 62c-11,11 -23,26 9,26z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "639,520 886,520 886,494 639,494 "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "639,715 852,715 853,689 640,689 "
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M2 715l70 0c0,-66 4,-55 -16,-62 -18,-6 -41,-16 -52,-32l-2 94z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M359 664l0 51 68 0 0 -92c-19,9 -16,18 -49,29 -15,5 -13,0 -19,12z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "639,617 805,617 805,592 639,592 "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "639,422 805,422 805,397 639,397 "
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M272 505c-16,7 -32,27 -49,37 -22,-4 -45,-34 -66,-45 2,75 108,72 115,8z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "542,715 621,715 621,689 542,689 "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "542,520 621,520 621,494 542,494 "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "542,617 621,617 621,592 542,592 "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "fil0",
  points: "542,422 621,422 621,397 542,397 "
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "M113 605c0,19 -4,72 4,87l10 0c7,-13 7,-91 1,-105l-12 0c-3,8 -3,5 -3,18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "M124 243c27,1 4,-11 29,-21 28,8 0,17 26,22 17,-14 -1,-37 -19,-40 -24,-4 -42,14 -36,39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "M249 243c18,-1 8,-5 21,-21 37,1 2,20 35,22 7,-21 -5,-40 -27,-40 -20,-1 -43,19 -29,39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "M188 373c10,29 63,-4 68,-20 5,-18 -2,-13 -3,-15 -18,-4 -8,7 -27,20 -17,11 -26,1 -38,15z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M56 274c0,-22 4,-41 -13,-41 -6,1 -8,3 -12,7 -16,18 1,33 25,34z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M383 251l0 7 0 16c68,-2 0,-75 0,-23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M74 166c17,-6 28,-19 35,-40l-35 0 0 40z"
}));

var SvgAlerts = function SvgAlerts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "39.8955mm",
    height: "32.2061mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 886 715",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlerts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alerts.3c11a26e.svg";
export { ForwardRef as ReactComponent };